// extracted by mini-css-extract-plugin
export default {"PrevColors":"styles_PrevColors__j69fb","content":"styles_content__7qw8K","color":"styles_color__cNGBL","active":"styles_active__p4iZF","noContent":"styles_noContent__0zQhP"};